import React, { useState, useEffect } from 'react';
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import { useAlert } from 'react-alert';
import { Button, Modal } from 'react-bootstrap';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BankingInfo from './BankingInfo';
import Liabilities from './Liabilities';

function HospitalDetails() {
  const { t } = useTranslation();
  const alert = useAlert();
  const { id } = useParams();
  const navigate = useNavigate();
  const { state: locationState } = useLocation();
  const userType = sessionStorage.getItem("user_type") || null;

  const [hospitalData, setHospitalData] = useState({
    spstatus: '',
    img: '',
    name: '',
    desc: '',
    mail: '',
    location: '',
    state1: '',
    number: '',
    facilities: [],
    country: '',
    website: '',
    acc: '',
    year: '',
    phone: '',
    emer: '',
    sp_type: '',
    prMail: '',
    regNum: '',
    type: '',
    street: '',
    deliveryRadious: '',
    status: '',
    countyCode: '',
    username: '',
    vendorId: '',
    isDergstr: false,
    hospital_plan: null
  });

  const [uiState, setUiState] = useState({
    selected: locationState?.selected || "home",
    refresh: false,
    deleteShow: false,
    approveShow: false,
    approveFail: false,
    rejectShow: false,
    rejectFail: false,
    confirm: false,
    modalShow: false,
    modalShowdel: false,
    errorShow: false,
    dlt: false,
    pendingAction: ''
  });

  const [messages, setMessages] = useState({
    approveMsg: '',
    approveFailMsg: '',
    rejectMsg: '',
    rejectFailMsg: ''
  });

  useEffect(() => {
    getProfile();
  }, [uiState.refresh]);

  useEffect(() => {
    setUiState(prev => ({ ...prev, refresh: !prev.refresh }));
  }, [id]);

  const getProfile = () => {
    const tokenString = sessionStorage.getItem("usertoken");
    const token = tokenString?.replace(/[\"]+/g, "") || "";

    axios.get(`${APIURL}/api/v1/staff/hospital-profile/?hospital_id=${id}&${TZ}`, {
      headers: { Authorization: "Token " + token },
    })
      .then((res) => {
        if (res.data.status === 'success') {
          const hospData = res.data.hospital_profile;
          setHospitalData({
            spstatus: res.data.account_status,
            img: hospData.photo,
            name: hospData.name,
            desc: hospData.description,
            mail: hospData.email,
            location: hospData.location,
            state1: hospData.state,
            number: hospData.mobile_number,
            countyCode: hospData.country_code,
            country: hospData.country,
            vendorId: hospData.vendor_id,
            website: hospData.website,
            acc: hospData.accreditation,
            sp_type: hospData.sp_type,
            year: hospData.established_year,
            hospital_plan: hospData.hospital_plan,
            phone: hospData.contact_phone,
            status: hospData.status,
            prMail: hospData.primary_email,
            regNum: hospData.reg_number,
            type: hospData.health_care_type,
            deliveryRadious: hospData.delivery_radius,
            street: hospData.street,
            isDergstr: hospData.is_deregister,
            username: hospData.username,
            facilities: hospData.facilities.join(', '),
            emer: hospData.contact_phone === null
              ? hospData.contact_phone
              : "+" + hospData.contact_code + " " + hospData.contact_phone
          });

          setUiState(prev => ({
            ...prev,
            dlt: res.data.message !== null
          }));
        } else {
          setUiState(prev => ({ ...prev, errorShow: true }));
        }
      })
      .catch((err) => {
        setUiState(prev => ({ ...prev, errorShow: true }));
      });
  };

  const handleDeleteModal = (status1) => {
    setUiState(prev => ({ ...prev, modalShowdel: true, pendingAction: status1 }));
  };

  const handleApprove = () => {
    const tokenString = sessionStorage.getItem("usertoken");
    const token = tokenString?.replace(/[\"]+/g, "") || "";

    axios.post(`${APIURL}/api/v1/staff/hospital-approve/`, { hospital_id: id }, {
      headers: { Authorization: "Token " + token },
    })
      .then((res) => {
        if (res.data.status === 'success') {
          alert.success(t('hospitalDetails.messages.approvedSuccessfully'));
          getProfile();
        } else {
          alert.error(t('hospitalDetails.messages.failedToSubmit'));
        }
      })
      .catch((err) => {
        setMessages(prev => ({ ...prev, approveFailMsg: t('hospitalDetails.messages.failedToSubmit') }));
        setUiState(prev => ({ ...prev, approveFail: true }));
      });
  };

  const handleDelete = () => {
    const tokenString = sessionStorage.getItem("usertoken");
    const token = tokenString?.replace(/[\"]+/g, "") || "";

    const data = {
      account_status: uiState.pendingAction,
      hospital_email: hospitalData.mail
    };

    axios.post(`${APIURL}/api/v1/staff/disable_delete_account/`, data, {
      headers: { Authorization: "Token " + token },
    })
      .then((res) => {
        if (res.data.status === 'success') {
          if (res.data.message && res.data.message === 'successfully disabled') {
            alert.success(t('hospitalDetails.messages.deactivatedSuccessfully'));
            setHospitalData(prev => ({ ...prev, spstatus: 'Disable' }));
          } else if (res.data.message && res.data.message === 'successfully Enabled') {
            alert.success(t('hospitalDetails.messages.activatedSuccessfully'));
            setHospitalData(prev => ({ ...prev, spstatus: 'Active' }));
          } else {
            alert.success(t('hospitalDetails.messages.deletedSuccessfully'));
            setHospitalData(prev => ({ ...prev, spstatus: 'Delete' }));
          }
          if (uiState.pendingAction === "Delete") {
            navigate("/hospitallist", { state: { approve: true } });
          }
          getProfile();
        } else if (res.data.status === 'error' && res.data.message === 'Vendor cannot be deleted because there are unpaid bills') {
          alert.error(t('hospitalDetails.messages.cannotDeleteDueToUnpaidBills'));
        } else {
          alert.error(t('hospitalDetails.messages.failedToSubmit'));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleReject = () => {
    const tokenString = sessionStorage.getItem("usertoken");
    const token = tokenString?.replace(/[\"]+/g, "") || "";

    axios.post(`${APIURL}/api/v1/staff/hospital-approve/`, {
      hospital_id: id,
      status: 'rejected'
    }, {
      headers: { Authorization: "Token " + token },
    })
      .then((res) => {
        if (res.data.status === 'success') {
          navigate("/hospitallist");
          alert.success(t('hospitalDetails.messages.rejectedSuccessfully'));
        } else {
          alert.error(res.data.message);
        }
      })
      .catch((err) => {
        setMessages(prev => ({ ...prev, rejectFailMsg: t('hospitalDetails.messages.failedToReject') }));
        setUiState(prev => ({ ...prev, rejectFail: true }));
      });
  };

  // Modal Components
  const ApprovalPopUp = (props) => (
    <Modal {...props} size="md" centered backdrop="static" keyboard={false}>
      <Modal.Body className="text-center">
        <br />
        <h4>{t('hospitalDetails.messages.approvedSuccessfully')}</h4>
        <br /><br />
        <Button variant="secondary" onClick={() => navigate("/hospitallist", { state: { approve: false } })}>
          {t('common.ok')}
        </Button>
      </Modal.Body>
    </Modal>
  );

  const DeletePopUp = (props) => (
    <Modal {...props} size="md" centered backdrop="static" keyboard={false}>
      <Modal.Body className="text-center">
        <br /><br />
        <h4 className='text-success'>
          {hospitalData.spstatus === "Delete" ? t('hospitalDetails.messages.deletedSuccessfully') :
            hospitalData.spstatus === "Active" ? t('hospitalDetails.messages.activatedSuccessfully') :
              t('hospitalDetails.messages.deactivatedSuccessfully')}
        </h4>
        <br /><br />
        <Button variant="secondary" onClick={props.onHide}>{t('common.ok')}</Button>
      </Modal.Body>
    </Modal>
  );

  const ApprovalFail = (props) => (
    <Modal {...props} size="md" centered backdrop="static" keyboard={false}>
      <Modal.Body className="text-center">
        <br />
        <h5 className="text-danger">{messages.approveFailMsg}</h5>
        <br /><br />
        <Button variant="secondary" onClick={props.onHide}>{t('common.ok')}</Button>
      </Modal.Body>
    </Modal>
  );

  const RejectPopUp = (props) => (
    <Modal {...props} size="md" centered backdrop="static" keyboard={false}>
      <Modal.Body className="text-center">
        <br />
        <h4>{t('hospitalDetails.messages.rejectedSuccessfully')}</h4>
        <br /><br />
        <Button variant="secondary" onClick={() => navigate("/hospitallist", { state: { approve: false } })}>
          {t('common.ok')}
        </Button>
      </Modal.Body>
    </Modal>
  );

  const RejectFail = (props) => (
    <Modal {...props} size="md" centered backdrop="static" keyboard={false}>
      <Modal.Body className="text-center">
        <br />
        <h5 className="text-danger">{t('hospitalDetails.messages.errorSubmission')}</h5>
        <br /><br />
        <Button variant="secondary" onClick={props.onHide}>{t('common.ok')}</Button>
      </Modal.Body>
    </Modal>
  );

  const DelConfirmPopUp = (props) => (
    <Modal {...props} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <h4 className={uiState.pendingAction === "Active" ? 'text-success' : 'text-danger'}>
          {uiState.pendingAction === "Delete" ? t('hospitalDetails.confirmations.delete') :
            uiState.pendingAction === "Active" ? t('hospitalDetails.confirmations.activate') :
              t('hospitalDetails.confirmations.deactivate')}
        </h4>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>{t('common.no')}</Button>
        <Button variant="danger" onClick={props.onCall}>{t('common.yes')}</Button>
      </Modal.Footer>
    </Modal>
  );

  const ConfirmPopUp = (props) => (
    <Modal {...props} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        <h4>{t('hospitalDetails.confirmations.areYouSure')}</h4>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>{t('common.no')}</Button>
        <Button variant="danger" onClick={props.onReject}>{t('common.yes')}</Button>
      </Modal.Footer>
    </Modal>
  );

  const ErrorPopUp = (props) => (
    <Modal {...props} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton />
      <Modal.Body className="text-center">
        {!uiState.dlt && <h5 className="text-danger">{t('hospitalDetails.messages.errorInData')}</h5>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>{t('common.ok')}</Button>
      </Modal.Footer>
    </Modal>
  );

  const navigationButton = (key, icon, label) => (
    <button
      className={uiState.selected === key ? "patientRecbutton1" : "patientRecbutton"}
      style={{ width: "100%", cursor: "pointer" }}
      onClick={() => setUiState(prev => ({ ...prev, selected: key }))}
    >
      &nbsp;{icon}&nbsp;{label}
    </button>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ marginTop: "1rem" }}>
        <h6 className="text-capitalize"><b>{hospitalData.name}</b></h6>
      </div>

      <div style={{ display: 'flex', gap: "1rem", minHeight: "71vh" }}>
        {/* Sidebar Navigation */}
        <div style={{ flex: '0 0 280px', minWidth: '280px' }}>
          <div className="det-div" style={{ padding: "1%" }}>
            {navigationButton("home", <HomeIcon />, t('hospitalDetails.navigation.home'))}
            {navigationButton("bankingInfo", <BankingIcon />, t('hospitalDetails.navigation.bankingInfo'))}
            {navigationButton("liabilities", <LiabilitiesIcon />, t('hospitalDetails.navigation.liabilities'))}
          </div>
        </div>

        {/* Main Content */}
        <div style={{ flex: '1', minWidth: 0, overflow: 'hidden' }}>
          {/* Content based on selection */}
          {uiState.selected === "home" && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {uiState.dlt ? (
                <>
                  <div className="det-div" style={{ padding: "2%" }}>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(2, 1fr)',
                      gap: '1rem',
                      width: '100%'
                    }}>
                      {[
                        { key: 'id', value: hospitalData.vendorId },
                        { key: 'registrationNumber', value: hospitalData.regNum || t('common.notAvailable') },
                        {
                          key: 'vendorType',
                          value: hospitalData.sp_type
                            ? t(`professionalsList.${hospitalData.sp_type}`, { defaultValue: hospitalData.sp_type })
                            : t('common.notAvailable')
                        },
                        { key: 'username', value: hospitalData.username },
                        { key: 'establishedYear', value: hospitalData.year || t('common.notAvailable') },
                        { key: 'email', value: hospitalData.mail || t('common.notAvailable') },
                        { key: 'location', value: `${hospitalData.street}, ${hospitalData.location}, ${hospitalData.state1}, ${hospitalData.country}` },
                        { key: 'phoneNumber', value: hospitalData.number ? `+${hospitalData.countyCode} ${hospitalData.number}` : t('common.notAvailable') },
                        { key: 'emergencyNumber', value: hospitalData.emer || t('common.notAvailable') },
                        { key: 'website', value: hospitalData.website || t('common.notAvailable') },
                        {
                          key: 'plan',
                          value: hospitalData.hospital_plan ? (
                            <span>
                              {t(`bankingInfo.${hospitalData.hospital_plan.version_name.toLowerCase()}`)}
                              ({t(`bankingInfo.${hospitalData.hospital_plan.plan_period.toLowerCase()}`)})
                            </span>
                          ) : (
                            <span style={{ opacity: 0.6 }}>{t('common.notAvailable')}</span>
                          )
                        }
                      ].map((item, index) => (
                        <div key={index} style={{ minWidth: 0 }}>
                          <p className="text-left" style={{
                            margin: '0.5rem 0',
                            wordBreak: 'break-word',
                            overflow: 'hidden'
                          }}>
                            {t(`hospitalDetails.fields.${item.key}`)}:
                            <span className='text-info span-size'> {item.value}</span>
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="det-div" style={{ padding: "2%" }}>
                    {hospitalData.status === "pending" ? (
                      <div className="text-center">
                        <ActionButton
                          color="red"
                          onClick={() => setUiState(prev => ({ ...prev, confirm: true }))}
                          label={t('hospitalDetails.buttons.reject')}
                        />
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <ActionButton
                          color="#272244"
                          onClick={handleApprove}
                          label={t('hospitalDetails.buttons.approve')}
                        />
                      </div>
                    ) : (
                      <div className="text-center">
                        <ActionButton
                          color="red"
                          onClick={() => handleDeleteModal('Delete')}
                          label={t('hospitalDetails.buttons.delete')}
                          disabled={userType === "staff"}
                        />
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        {(hospitalData.spstatus === "ACTIVE" || hospitalData.spstatus === "Active") ? (
                          <ActionButton
                            color="#fc9a03"
                            onClick={() => handleDeleteModal('Disable')}
                            label={t('hospitalDetails.buttons.deactivate')}
                            disabled={userType === "staff"}
                          />
                        ) : (
                          <ActionButton
                            color="#272244"
                            onClick={() => handleDeleteModal('Active')}
                            label={t('hospitalDetails.buttons.activate')}
                            disabled={userType === "staff"}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div className="row">
                  <div className="col-7">
                    <h3 className="text-danger">{t('hospitalDetails.messages.providerDeleted')}</h3>
                  </div>
                </div>
              )}
            </div>
          )}

          {uiState.selected === "bankingInfo" && <BankingInfo />}
          {uiState.selected === "liabilities" && <Liabilities hospitalId={id} />}

          {/* Modal Renderers */}
          {messages.approveMsg && <ApprovalPopUp show={uiState.approveShow} onHide={() => { setUiState(prev => ({ ...prev, approveShow: false })); setMessages(prev => ({ ...prev, approveMsg: '' })); }} />}
          {messages.approveFailMsg && <ApprovalFail show={uiState.approveFail} onHide={() => { setUiState(prev => ({ ...prev, approveFail: false })); setMessages(prev => ({ ...prev, approveFailMsg: '' })); }} />}
          {messages.rejectMsg && <RejectPopUp show={uiState.rejectShow} onHide={() => { setUiState(prev => ({ ...prev, rejectShow: false })); setMessages(prev => ({ ...prev, rejectMsg: '' })); }} />}
          {messages.rejectFailMsg && <RejectFail show={uiState.rejectFail} onHide={() => { setUiState(prev => ({ ...prev, rejectFail: false })); setMessages(prev => ({ ...prev, rejectFailMsg: '' })); }} />}
          {uiState.confirm && <ConfirmPopUp show={uiState.confirm} onHide={() => setUiState(prev => ({ ...prev, confirm: false }))} onReject={() => { handleReject(); setUiState(prev => ({ ...prev, confirm: false })); }} />}
          {uiState.modalShowdel && <DelConfirmPopUp show={uiState.modalShowdel} onCall={() => { handleDelete(); setUiState(prev => ({ ...prev, modalShowdel: false })); }} onHide={() => { setUiState(prev => ({ ...prev, refresh: !prev.refresh, modalShowdel: false })); }} />}
          {uiState.errorShow && <ErrorPopUp show={uiState.errorShow} onHide={() => setUiState(prev => ({ ...prev, errorShow: false }))} />}
          {uiState.deleteShow && <DeletePopUp show={uiState.deleteShow} onHide={() => { hospitalData.spstatus === "Delete" ? navigate("/hospitallist", { state: { approve: true } }) : setUiState(prev => ({ ...prev, deleteShow: false })); getProfile(); }} />}
        </div>
      </div>
    </div>
  );
}

const ActionButton = ({ color, onClick, label, disabled = false }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    style={{
      boxShadow: "3px 5px 10px rgba(0,0,0,0.2)",
      padding: "1.5%",
      fontSize: "small",
      color: "white",
      backgroundColor: color,
      border: "none",
      borderRadius: "5px",
      cursor: disabled ? "not-allowed" : "pointer",
      opacity: disabled ? 0.6 : 1
    }}
  >
    {label}
  </button>
);

// Icon Components
const HomeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">
    <path fill="currentColor" fillRule="evenodd" d="M20 4a3 3 0 0 0-3 3h-3a3 3 0 0 0-3 3v28a3 3 0 0 0 3 3h12v-2H14a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h3a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3h3a1 1 0 0 1 1 1v15h2V10a3 3 0 0 0-3-3h-3a3 3 0 0 0-3-3h-8Zm-1 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V7Zm4 12v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3Zm4 9a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6.789a7 7 0 0 1-3.117 5.824l-3.328 2.22a1 1 0 0 1-1.11 0l-3.328-2.22A7 7 0 0 1 27 34.79V28Zm2 1v5.789a5 5 0 0 0 2.227 4.16L34 40.8l2.773-1.85A5 5 0 0 0 39 34.79V29H29Zm4.707 7.707l4-4l-1.414-1.414L33 34.586l-1.293-1.293l-1.414 1.414l2 2a1 1 0 0 0 1.414 0Z" clipRule="evenodd" />
  </svg>
);

const BankingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 9a2 2 0 1 0 0 4a2 2 0 0 0 0-4Zm-4 8.5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Z" />
    <path fill="currentColor" fillRule="evenodd" d="M7 2.25A2.75 2.75 0 0 0 4.25 5v14A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19V8.198a1.75 1.75 0 0 0-.328-1.02L16.408 2.98a1.75 1.75 0 0 0-1.421-.73H7ZM5.75 5c0-.69.56-1.25 1.25-1.25h7.25v4.397c0 .414.336.75.75.75h3.25V19c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25V5Z" clipRule="evenodd" />
  </svg>
);

const LiabilitiesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="currentColor" d="M3 3h18v2H3V3zm2 4h14v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7zm4 2v2h6V9H9z" />
  </svg>
);

export default HospitalDetails;